// extracted by mini-css-extract-plugin
export default {"mdf_container":"AMeTx9HTLAubSFHiCbSI","mdf_content":"KbWQYMHK9aa5wWl1EmQn"};